import ReceiptsList from "./ReceiptsList";

export default ReceiptsList;
